<div class="tools-height">
    <button type="button" class="btn btn-raised btn-success btn-sm btn-action me-1"
        (click)="$event.stopPropagation();editItemClicked(element)">
        <span class="fa fa-edit"></span> Edit
    </button>
    <button type="button" class="btn btn-raised btn-warning btn-sm btn-action me-1"
        (click)="$event.stopPropagation();cloneItemClicked(element)">
        <span class="fa fa-clone"></span> Clone
    </button>
    <button type="button" class="btn btn-raised btn-danger btn-sm btn-action me-1"
        (click)="$event.stopPropagation();deleteItemClicked(element)">
        <span class="fa fa-trash"></span> Remove
    </button>
</div>
